module.exports = __webpack_public_path__ + "static/img/5-1.d6a861a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/5-1.jpg
// module id = nLaD
// module chunks = 0